import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import CustomSelectInput from '../CustomSelectInput';
import ClassificationCodeSelect from './ClassificationCode';

const ItemClassificationFields = ({ control, errors, readOnly, watch, setValue, edit = false }) => {
  const rawCommodityCode = watch('commodity_code');
  const itemType = rawCommodityCode?.value || rawCommodityCode || null;
  const isBoth = itemType === 'B';
  const gridSize = isBoth ? 4 : 6;
  const mainGridSize = isBoth ? 4 : 6;

  useEffect(() => {
    if (!edit) {
      if (itemType === 'G') {
        setValue('service_accounting_code', null);
      } else if (itemType === 'S') {
        setValue('item_classification_identifier', null);
      }
    }
  }, [itemType, edit, setValue]);

  return (
    <>
      <Grid size={mainGridSize}>
        <CustomSelectInput
          name="commodity_code"
          control={control}
          errors={errors}
          label="Item Type"
          readOnly={readOnly}
          options={[
            { label: 'Goods', value: 'G' },
            { label: 'Services', value: 'S' },
            { label: 'Both', value: 'B' },
          ]}
        />
      </Grid>

      {(itemType === 'G' || itemType === 'B') && (
        <Grid size={gridSize}>
          <ClassificationCodeSelect
            label="Item Classification Identifier"
            name="item_classification_identifier"
            control={control}
            errors={errors}
            readOnly={readOnly}
          />
        </Grid>
      )}

      {(itemType === 'S' || itemType === 'B') && (
        <Grid size={gridSize}>
          <ClassificationCodeSelect
            label="Service Accounting Code"
            name="service_accounting_code"
            control={control}
            errors={errors}
            readOnly={readOnly}
          />
        </Grid>
      )}
    </>
  );
};

export default ItemClassificationFields;
